import { Autocomplete, TextField } from "@mui/material";
import React from "react";
import { DbMetadataFieldInfos } from "../../../../Core/Api/Types/db-metadata-field-infos";
interface ValueSetterProps {
  value: string;
  onChange: (e: any, tokenIndex: number, field: string, ruleIndex: number, nrIndex: number) => void;
  metadataFields: DbMetadataFieldInfos[];
  tokenIndex: number;
  field: string;
  ruleIndex: number;
  nrIndex: number;
}
const ValueSetter: React.FC<ValueSetterProps> = ({
  metadataFields,
  onChange,
  value = "",
  field,
  tokenIndex,
  ruleIndex,
  nrIndex,
}) => {
  const lastInput = value
    ? value.split
      ? value.split("%").length > 1
        ? `%${value.split("%")[value.split("%").length - 1]}`
        : value
      : value
    : value;

  return (
    <Autocomplete
      filterOptions={(options) => options.filter((o) => o.includes(lastInput))}
      value={value}
      freeSolo
      sx={{
        ".MuiInputBase-root": {
          margin: "0px !important",
        },
      }}
      options={metadataFields.map((x) => `%${x.tagName}%`)}
      onChange={(e, v) =>
        onChange(
          v === null ? "" : `${value.substring(0, value.length - lastInput.length)}${v}`,
          tokenIndex,
          field,
          ruleIndex,
          nrIndex
        )
      }
      getOptionLabel={(option) => `${option}`}
      renderInput={(params) => (
        <TextField
          onChange={(e) => onChange(e.target.value, tokenIndex, field, ruleIndex, nrIndex)}
          sx={{ width: Math.max((params.inputProps.value ?? "").toString().length - 10, 0) * 7 + 150 }}
          {...params}
        />
      )}
    />
  );
};

export default ValueSetter;
